var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useButtonStyles } from "./Button.styles";
function getMode(buttonType) {
    switch (buttonType) {
        case "primary":
            return "buttonPrimary";
        case "secondary":
            return "buttonSecondary";
        case "tertiary":
            return "buttonTertiary";
        case "link":
            return "buttonLink";
        default:
            return "buttonPrimary";
    }
}
export var Button = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.buttonType, buttonType = _c === void 0 ? "secondary" : _c, htmlId = _a.htmlId, label = _a.label, icon = _a.icon, thin = _a.thin, _d = _a.type, type = _d === void 0 ? "button" : _d, ariaLabel = _a.ariaLabel, onClick = _a.onClick, dark = _a.dark, light = _a.light, props = __rest(_a, ["className", "buttonType", "htmlId", "label", "icon", "thin", "type", "ariaLabel", "onClick", "dark", "light"]);
    var classes = useButtonStyles({ dark: dark, light: light, thin: thin });
    return (_jsx("button", __assign({ className: "".concat(className, " ").concat(classes.buttonBase, " ").concat(classes[getMode(buttonType)]), id: htmlId, onClick: onClick }, props, { type: type }, { children: _jsxs("span", __assign({ className: classes.myLabel }, { children: [icon && _jsx("span", __assign({ className: classes.myIcon }, { children: icon })), label || (props === null || props === void 0 ? void 0 : props.children)] })) })));
};
